import { IconButton } from '@atlaskit/button/new';
import CrossIcon from '@atlaskit/icon/core/cross';
import Tooltip from '@atlaskit/tooltip';
import { css } from '@compiled/react';
import { AdControls } from '@post-office/components--ad-controls';
import { useMessageInstanceEvent } from '@post-office/message-instance-event-frontend-client';
import { useMessageEvent } from '@post-office/message-lifecycle';
import { type ComponentProps, type FunctionComponent } from 'react';
import { useIntl } from 'react-intl-next';

type PropsWithOnDismissed = {
	onDismissed: () => void;
	whyAmISeeingThisModalContent?: ComponentProps<typeof AdControls>['whyAmISeeingThisModalContent'];
};

const DismissButton: FunctionComponent<PropsWithOnDismissed> = ({ onDismissed }) => {
	const { messageDismissed } = useMessageEvent();
	const { messageInstanceClicked } = useMessageInstanceEvent();

	const intl = useIntl();
	const tooltip = intl.formatMessage({
		id: 'post-office.close-button.tooltip',
		defaultMessage: 'Close',
		description: 'Tooltip for close button',
	});

	return (
		<Tooltip content={tooltip}>
			<IconButton
				shape="default"
				appearance="subtle"
				label="close"
				icon={(iconProps) => <CrossIcon {...iconProps} size="small" />}
				onClick={() => {
					onDismissed();
					messageDismissed().catch(() => {});
					messageInstanceClicked({
						messageEventType: 'clicked',
						clickedElement: {
							clickIdentifier: 'close',
							clickedElement: 'button',
							buttonType: 'primary',
						},
						action: {
							actionType: 'dismiss',
						},
						additionalMetadataFromFrontend: {},
					}).catch(() => {});
				}}
			/>
		</Tooltip>
	);
};

const actionsStyles = css({
	display: 'flex',
});

export const Actions: FunctionComponent<PropsWithOnDismissed> = ({
	onDismissed,
	whyAmISeeingThisModalContent,
}) => {
	return (
		<div css={actionsStyles}>
			<AdControls
				iconSize="small"
				onDismissed={onDismissed}
				showWhyAmISeeingThis={true}
				whyAmISeeingThisModalContent={whyAmISeeingThisModalContent}
			/>
			<DismissButton onDismissed={onDismissed} />
		</div>
	);
};
